import { render, staticRenderFns } from "./ProductCreationWorkshopModal.vue?vue&type=template&id=88105034&"
import script from "./ProductCreationWorkshopModal.vue?vue&type=script&lang=js&"
export * from "./ProductCreationWorkshopModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreationWorkshopModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports